export const APP_SETTINGS = {
  ALLOW_SWITCH_LANGUAGE: false
};
